import React from 'react';
import { Box } from '@hub/box';
import MemberExclusiveSmallSVG from '../../assets/images/MemberExclusiveSmall.inline.svg';
import MemberExclusiveLargeSVG from '../../assets/images/MemberExclusiveLarge.inline.svg';
import { jsx as _jsx } from "react/jsx-runtime";

const MemberExclusiveLabel = _ref => {
  let {
    sx,
    display,
    option
  } = _ref;

  if (!display) {
    return null;
  }

  let memberExclusive = null;
  memberExclusive = option === 'small' ? /*#__PURE__*/_jsx(MemberExclusiveSmallSVG, {
    "data-id": "member-exclusive-label_index_MemberExclusiveLabel_MemberExclusiveSmallSVG"
  }) : /*#__PURE__*/_jsx(MemberExclusiveLargeSVG, {
    "data-id": "member-exclusive-label_index_MemberExclusiveLabel_MemberExclusiveLargeSVG"
  });
  return /*#__PURE__*/_jsx(Box, {
    sx: sx,
    "data-id": "member-exclusive-label_index_MemberExclusiveLabel_Box",
    children: memberExclusive
  });
};

export default MemberExclusiveLabel;